module.exports = __webpack_public_path__ + "static/media/building.932e572f.png";